import React from 'react';
import { observer } from 'mobx-react-lite';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { toTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { KbSuggestionFieldWrapper } from './common/KbSuggestionFieldWrapper';
import { EditShortText } from './edit/EditShortText';
import { ViewShortText } from './view/ViewShortText';
export const ShortText = observer(({
  id,
  questionStore,
  displayMode
}) => {
  const value = toTextQuestionAnswer(questionStore.currentAnswer);
  const showEditComponent = displayMode === DisplayMode.Edit && !(getBooleanFF('platform.proforma-read-only-questions.wewrsr') && questionStore.formQuestion.readOnly);
  if (showEditComponent) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditShortText, {
      id: id,
      value: value,
      isInvalid: !!questionStore.validationErrors,
      onChange: event => questionStore.setAnswer(event.target.value)
    }), /*#__PURE__*/React.createElement(KbSuggestionFieldWrapper, {
      questionStore: questionStore
    }));
  }
  return /*#__PURE__*/React.createElement(ViewShortText, {
    id: id,
    value: value,
    displayMode: displayMode
  });
});